import { ToastContainer } from "react-toastify";
import Routers from "./Routes/Routers";
import { Fragment } from "react/jsx-runtime";

const App = () => {
  return (
    <Fragment>
      <Routers />
      <ToastContainer />
    </Fragment>
  );
};

export default App;
